export const BASENAME = "/mylocalmerchantservicesfront";